(function () {
    function openList(trigger,list) {
      list.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
    }
    function closeList(trigger,list) {
      list.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    }
    document.querySelectorAll('.country-selector').forEach(wrapper => {
        var trigger = wrapper.querySelector('.country-selector__trigger');
        var list = wrapper.querySelector('.country-selector__list');
        var input = wrapper.querySelector('.CountryCodeInput');
        var form = wrapper.querySelector('.CountryLocalizationForm');
        var currentLabel = wrapper.querySelector('.country-selector__current');
    
        if(!trigger || !list || !input || !form)return false;
        trigger.addEventListener('click', function (e) {
          e.stopPropagation();
          if (list.hidden) {
            openList(trigger,list);
          } else {
            closeList(trigger,list);
          }
        });
    
        list.querySelectorAll('.country-selector__option').forEach(function (option) {
          option.addEventListener('click', function () {
            input.value = option.getAttribute('data-country-code');
            currentLabel.textContent = option.getAttribute('data-country-label');
            closeList(trigger,list);
            form.submit();
          });
        });
    
        document.addEventListener('click', function (e) {
          if (!wrapper.contains(e.target)) closeList(trigger,list);
        });
    
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') closeList(trigger,list);
        });
    })
  })();